import Swiper from "swiper/swiper-bundle";
// import "swiper/css/bundle";

function initImgSlider() {
  const swiper = new Swiper(".v2-img-slider-w-modal", {
    slidesPerView: 1.8,
    spaceBetween: 16,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 2500,
    },
    pagination: {
      el: ".v2-img-slider-w-modal-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 480px
      900: {
        spaceBetween: 40,
      },
    },
  });
}

export { initImgSlider };

function initImgSliderAlt() {
  const swiper = new Swiper(".v2-img-slider-w-modal-single-gallery", {
    slidesPerView: 1,
    spaceBetween: 15,
    // centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: ".v2-img-slider-w-modal-single-gallery-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".v2-img-slider-w-modal-single-gallery-next",
      prevEl: ".v2-img-slider-w-modal-single-gallery-prev",
    },
    breakpoints: {
      600: {
        spaceBetween: 15,
        slidesPerView: 2,
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 3,
      },
    },
  });
}

export { initImgSliderAlt };
